export const openSupportChat = ({ maxRetries = 60, intervalMs = 500 } = {}) =>
  new Promise(resolve => {
    if (typeof window === 'undefined') {
      resolve(false)
      return
    }

    let attempts = 0
    const tryOpen = () => {
      attempts += 1
      const openWhenReady = window.ChatPlugin?.openWhenReady
      if (typeof openWhenReady === 'function') {
        try {
          Promise.resolve(openWhenReady.call(window.ChatPlugin, true))
            .then(result => resolve(result !== false))
            .catch(() => resolve(false))
          return
        } catch {}
      }
      if (attempts >= maxRetries) {
        resolve(false)
        return
      }
      setTimeout(tryOpen, intervalMs)
    }
    tryOpen()
  })
